import React from "react"
import { useTranslation } from "react-i18next";

// MUI
import { Box, Toolbar } from "@mui/material";

//Custom Components
import DraggableDialog from "@/ui/Dialog/DraggableDialog";
import DialogHeader from "@/ui/Dialog/DialogHeader";
import DialogBody from "@/ui/Dialog/DialogBody";
import DialogToolbarHeading from "@/ui/Dialog/DialogToolbarHeading";
import ToolbarFillContent from "@/ui/Toolbar/ToolbarFillContent";
import DialogToolbarButtonClose from "@/ui/Dialog/ToolbarButtons/DialogToolbarButtonClose";

interface ImageDialogProps {
  image?: any,
  onClose: () => void,
  imagePath?: string
}

const imageStyles: React.CSSProperties = {
  minHeight:"50vh",
  maxHeight: "75vh",
  minWidth:"40vw",
  maxWidth:"70vw",
  borderRadius: "5px",
  objectFit:"contain"
};

function ImageDialog(props: ImageDialogProps) {
  const { image, onClose,imagePath } = props
  const { t } = useTranslation();

  //console.log(imagePath)

  const handleClose = () => {
    onClose();
  }

  return (
    <DraggableDialog 
      open={true} 
      onClose={handleClose} 
      PaperProps={{ 
        style: { 
            maxWidth: '80vw',
            maxHeight: "90vh",
            marginTop: "10vh"
        },
        zIndex: 1300
  }}>
      <DialogHeader>
        <Toolbar variant="dense" disableGutters={true}>
            <DialogToolbarHeading>{t("titles.photo")}</DialogToolbarHeading>
            <ToolbarFillContent />
            <DialogToolbarButtonClose onClick={handleClose} />
        </Toolbar>
      </DialogHeader>
      <DialogBody>
        <Box m={2} display="flex" justifyContent="center" alignItems="center">
          {image || imagePath ? <img src={imagePath?imagePath:`data:image/jpeg;base64, ${image}`} style={imageStyles} /> : null}
        </Box>
      </DialogBody>
    </DraggableDialog>
  )


}

export default ImageDialog